import { parse, format, isValid } from 'date-fns'
import { DATE_FORMAT } from '@/components/Search/constants'

export const formatDate = (
  date: Date | string | null,
  dateFormat: string = DATE_FORMAT
): string => {
  if (!date) return ''

  // Convert string to Date if needed
  const parsedDate =
    typeof date === 'string'
      ? parse(date, dateFormat, new Date())
      : date

  // Validate and format
  return isValid(parsedDate) ? format(parsedDate, dateFormat) : ''
}


export const getYearDateRange = () => {
  const today = new Date();
  const oneYearAgo = new Date();
  oneYearAgo.setDate(today.getDate() - 365);
  return { start: oneYearAgo, end: today };
}